export default function (type) {
  var data = {}
  if (type == 'Titre') {
    data = {
      //isDone: false,
      exerciceTitle: 'Titre',
      type: 'Titre',
      title: 'Titre',
      subTitle: 'Sous-titre',
      icon: 'https://video.thelab.risinguparis.com/question.svg',
      //text: '<p>Ajoutez du texte</p>',
      button: { type: 'primary', text: 'Suivant' },
    }
  } else if (type == 'Texte') {
    data = {
      //isDone: false,
      exerciceTitle: 'Texte',
      type: 'Texte',
      title: 'Titre',
      subTitle: 'Sous-titre',
      text : 'Ajoutez du texte',
      //text: '<h5>Sous-titre</h5><p>Ajoutez du texte</p>',
      button: { type: 'primary', text: 'Suivant' },
    }
  } else if (type == 'Video') {
    data = {
      //isDone: false,
      exerciceTitle: 'Vidéo',
      type: 'Video',
      duration: 3,
      title: 'Titre',
      text: '<p>Ajoutez du texte<p>',
      buttonStart: { type: 'primary', text: 'Lancer la vidéo!' },
      buttonNext: { type: 'primary', text: 'Suivant' },
      playbackId: 'L274lqjjgdGoh00l02U502KnyQhKnRiJMEHyr4Aq44003yg',
    }
  } else if (type == 'QuestionnaireV2') {
    data = {
      //isDone: false,
      //userChoice: [],
      categorie: 'master',
      type: 'QuestionnaireV2',
      exerciceTitle: 'Questionnaire',
      questions: 'Ecrire la question ici',
      multi: false,
      button: { type: 'primary', text: 'Suivant' },
      responses: [
        { points: 0, label: '1' },
        { points: 1, label: '2' },
        { points: 2, label: '3' },
        { points: 3, label: '4' },
      ]
    }
  } else if (type == 'Quizz') {
    data = {
      //isDone: false,
      type: 'Quizz',
      //userChoice: [],
      //userIsValid: null,
      categorie: 'master',
      exerciceTitle: 'Quizz',
      noValidAnswer: false,
      multi: false,
      button: { type: 'primary', text: 'Suivant' },
      buttonNext: { type: 'primary', text: 'Valider' },
      questions: 'Ecrire la question ici',
      responses: [
        {
          points: 1,
          reponse: 'VRAI',
          isValid: true,
        },
        {
          points: 0,
          reponse: 'FAUX',
          isValid: false,
        },
      ],
      answers: {
        good: 'Bonne réponse !',
        bad: 'Mauvaise réponse',
        text: '',
      },
    }
  } else if (type == 'Diagnostic') {
    data = {
      //isDone: false,
      //userResult: null,
      type: 'Diagnostic',
      isChapter: false,
      exerciceTitle: 'Diag',
      title: 'Feedback',
      button: { type: 'primary', text: 'Suivant' },
      total: [
        {
          seuil: 50,
          title: null,
          text: 'Bravo ! Vous êtes sur le bon chemin, vous avez une bonne connaissance de votre connaissance ! Continuez à découvrir vos capacités !',
        },
       {
          seuil: 0,
          title: null,
          text: 'Vous êtes sur le bon chemin, vous avez identifié les espaces où peuvent se loger de nouvelles connaissances ! A vous de les compléter au fur et à mesure de cette formation !',
        } ,
      ],
      categorie: [
        {key: 'master', title: null, position: 0, seuils: [{ seuil: 0, text: null}]}
      ],
    }
  } else if (type === "InputTexte") {
    data = {
      type: 'InputTexte',
      exerciceTitle : 'Input Texte',
      button: { type: 'primary', text: 'Suivant' },
      questions: 'Ecrire la question ici',
      answers : {type : 'input'},
    }
  }
  return JSON.parse(JSON.stringify(data))
}
